import React from 'react'
import ContentLoader from 'react-content-loader'

const LoaderCommon = ({  }) => {



    return (
      <ContentLoader
        speed={2}
        width={400}
        height={400}
        viewBox={`0 0 420 400`}
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
      >
          <>
            <>
              <rect x="10" y="50" rx="3" ry="3" width="400" height="40" />
              <rect x="10" y="140" rx="3" ry="3" width="400" height="40" />
              <rect x="10" y="230" rx="3" ry="3" width="400" height="80" />
            </>
          </>
      </ContentLoader>
    )

}

export default LoaderCommon